import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

export default class extends Controller {
  static targets = ["notification"];

  connect() {
    this.show();

    setTimeout(() => {
      this.dismiss();
    }, 4000);
  }

  disconnect() {}

  show() {
    enter(this.notificationTarget);
  }

  dismiss() {
    leave(this.notificationTarget).then(this.element.remove());
  }
}
